export class AppError {
    MessageId: string | undefined;
    constructor(public originalError?: any) { }
  
    Message: string | undefined;
}
